import React, { useEffect, useState } from 'react'
import { GiCancel } from 'react-icons/gi';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { TiSpanner } from 'react-icons/ti';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCheckupReportApi } from '../../service/api/homeMaintenance/getCheckupReport';
import searchImg from '../../media/images/servicesAssets/searchImg.png'
import { Modal, Spinner } from 'react-bootstrap';
import { MdOutlineCancel } from 'react-icons/md';
import { LuArrowUpDown } from 'react-icons/lu';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaSearch } from 'react-icons/fa';
import { getHomeMaintenancePlansApi } from '../../service/api/homeMaintenance/getHomeMaintenancePlans';
import deleteMaintenancePlanApi from '../../service/api/homeMaintenance/deleteMaintenancePlan';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import InputField from '../../jsx/components/fields/inputField';
import SelectInputFrequency from '../../jsx/components/fields/selectInputFrequency';
import SelectInputPeriod from '../../jsx/components/fields/selectInputPeriod';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import addUpdateMaintenancePlanApi from '../../service/api/homeMaintenance/addUpdateMaintenancePlan';
import updateMaintenancePlanStatusApi from '../../service/api/homeMaintenance/updateMaintenancePlanStatus';

const MaintenanceTasks = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [maintenanceTabsToggle, setMaintenanceTabsToggle] = useState(4);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [columnName, setColumnName] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);

    const [checkupResultsArr, setCheckupResultsArr] = useState([]);
    const [checkupResultCompleteObj, setCheckupResultCompleteObj] = useState({});

    const [maintenanceObj, setMaintenanceObj] = useState({});
    const [maintenancePlansArr, setMaintenancePlansArr] = useState([]);

    const [isExpandedForProduct, setIsExpandedForProduct] = useState("");
    const [isExpandedForMaintenancePlan, setIsExpandedForMaintenancePlan] = useState("");

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);
    const [flag, setFlag] = useState(false);

    const handleCheckUpTabs = (val) => {
        setMaintenanceTabsToggle(val)
    }
    const backToPrevious = () => {
        navigate(-1)
    }


    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? "am" : "pm";
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    const [imageAttachURL, setImageAttachURL] = useState('');
    const [openDoc, setOpenDoc] = React.useState(false);
    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);



    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }


    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    const handleSearch = (e) => {
        // setPage(1)
        setPage(1);
        if (searchValue.trim().length >= 2) {
            setColumnName("");
        }
        setSearchValue(e.target.value);
    };

    useEffect(() => {
        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(getHomeMaintenancePlansFn, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
            if (flag) {
                getHomeMaintenancePlansFn();
            }
        }
    }, [searchValue]);

    const [allHomeMaintenancePlanCount, setAllHomeMaintenancePlanCount] = useState(0);
    const [secondCount, setSecondCount] = useState(0);
    const [thirdCount, setThirdCount] = useState(0);
    const [fourthCount, setFourthCount] = useState(0);

    const getHomeMaintenancePlansFn = () => {
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        maintenanceTabsToggle != 4 && data.append("no_of_days_flag", maintenanceTabsToggle);
        data.append("pagination_flag", 0);
        // data.append("page_index", page);
        // data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);

        dispatch(
            getHomeMaintenancePlansApi(data, (res) => {
                setMaintenanceObj(res);
                setMaintenancePlansArr(res?.data);
                setPeriodListArr(res?.period_list);
                res?.all_home_maintenance_plan_count && setAllHomeMaintenancePlanCount(res?.all_home_maintenance_plan_count);
                res?.home_maintenance_plan_in_30_days_count && setSecondCount(res?.home_maintenance_plan_in_30_days_count);
                res?.home_maintenance_plan_in_60_days_count && setThirdCount(res?.home_maintenance_plan_in_60_days_count);
                res?.home_maintenance_plan_in_90_days_count && setFourthCount(res?.home_maintenance_plan_in_90_days_count);
            }, (err) => { })
        );
    };

    useEffect(() => {
        getHomeMaintenancePlansFn();
    }, [maintenanceTabsToggle, filtreValue]);

    // Functions for the maintenance plans 
    const [maintenanceModalTrigger, setMaintenanceModalTrigger] = useState(false);
    const [toggleForMaintenancePlan, setToggleForMaintenancePlan] = useState(1);

    const [periodListArr, setPeriodListArr] = useState([]);

    const [homeAreaProductId, setHomeAreaProductId] = useState("");
    const [maintenancePlanId, setMaintenancePlanId] = useState("");
    const [instruction, setInstruction] = useState("");
    const [isInstructionErr, setIsInstructionErr] = useState(false);
    const [frequency, setFrequency] = useState("");
    const [isFrequencyErr, setIsFrequencyErr] = useState(false);
    const [period, setPeriod] = useState("");
    const [isPeriodErr, setIsPeriodErr] = useState(false);
    const [purchaseLink, setPurchaseLink] = useState("");
    const [maintenancePlanLoading, setMaintenancePlanLoading] = useState(false);

    const frequencyArr = [1, 2, 3, 4, 5];

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState("");
    const [handleToaster, setHandleToaster] = useState(false);

    const handleOpenMaintenancePlanModal = (val = 1) => {
        setMaintenanceModalTrigger(true);

        setToggleForMaintenancePlan(val);
    }

    const handleCloseMaintenancePlanModal = () => {
        setMaintenanceModalTrigger(false);

        clearMaintenancePlanStates();
    }

    const updateMaitenancePlanFn = (data) => {
        setHomeAreaProductId(data?.home_area_product_id_lng);
        setMaintenancePlanId(data?.maintenance_plan_id_ids);
        setInstruction(data?.instruction_chr);
        setFrequency(data?.frequency_int);
        setPeriod(data?.period_int);
        setPurchaseLink(data?.purchase_link);

        handleOpenMaintenancePlanModal(1);
    }

    const deletemaintenancePlanFn = (data) => {

        setMaintenancePlanLoading(true);
        let details = {
            maintenance_plan_id_ids: maintenancePlanId,
        };
        dispatch(
            deleteMaintenancePlanApi(details, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("success")
                setMaintenancePlanLoading(false);

                getHomeMaintenancePlansFn();
                handleCloseMaintenancePlanModal();

                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);
            }, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("error");
                setMaintenancePlanLoading(false);

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }
            )
        )
    }

    const clearMaintenancePlanStates = () => {
        setHomeAreaProductId("");
        setMaintenancePlanId("");
        setInstruction("");
        setFrequency("");
        setPeriod("");
        setPurchaseLink("");
        setIsInstructionErr(false);
        setIsFrequencyErr(false);
        setIsPeriodErr(false);
    }

    // Add maintenance plan functions
    const handleChangeInstruction = (e) => {
        setInstruction(e.target.value);
        setIsInstructionErr(false);
    }

    const handleBlurCheckInstrction = () => {
        if (instruction === "") {
            setIsInstructionErr(true);
        }
    }

    const handleChangeFreq = (e) => {
        setFrequency(e.target.value);
        setIsFrequencyErr(false);
    }

    const handleChangePeriod = (e) => {
        setPeriod(e.target.value);
        setIsPeriodErr(false);
    }

    const handleChangePurchaseLink = (e) => {
        setPurchaseLink(e.target.value);
    }

    const addUpdateMaintenancePlanFn = () => {
        if (instruction === "") {
            setIsInstructionErr(true);
        }
        if (frequency === "") {
            setIsFrequencyErr(true);
        }
        if (period === "") {
            setIsPeriodErr(true);
        }

        if (instruction !== "" && frequency !== "" && period !== "") {
            // console.log("addUpdateMaintenancePlanFn")
            // console.log("instruction", instruction)
            // console.log("frequency", frequency)
            // console.log("period", period)
            // console.log("purchase link", purchaseLink)

            setMaintenancePlanLoading(true);

            let data = new FormData();
            data.append("maintenance_plan_id_ids", maintenancePlanId);
            data.append("home_area_product_id_ids", homeAreaProductId);
            data.append("instruction_chr", instruction);
            data.append("frequency_int", frequency);
            data.append("period_int", period);
            data.append("purchase_link", purchaseLink);

            dispatch(
                addUpdateMaintenancePlanApi(data, (res) => {
                    setMaintenancePlanLoading(false)
                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    clearMaintenancePlanStates();

                    getHomeMaintenancePlansFn();

                    handleCloseMaintenancePlanModal();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                }, (err) => {
                    setMaintenancePlanLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            )

        }
    }

    // Functions for the completing the maintenance tasks list

    const [updateMaintenancePlanStatusLoading, setUpdateMaintenancePlanStatusLoading] = useState(false);
    const updateMaintenancePlanStatusFn = (data) => {
        setUpdateMaintenancePlanStatusLoading(true);

        const details = new FormData();
        details.append("maintenance_plan_id_ids", data?.maintenance_plan_id_ids);
        details.append("is_completed_ysn", data?.is_completed_ysn == 1 ? 0 : 1);

        dispatch(
            updateMaintenancePlanStatusApi(
                details,
                (res) => {

                    // console.log(res.message)
                    setResponceMsg(res.message)
                    setToasterType("success")
                    // setToggleForPurchase(1);

                    getHomeMaintenancePlansFn();


                    setMaintenancePlanId('');
                    setUpdateMaintenancePlanStatusLoading(false)

                    // setTimeout(() => {
                    //     setMaintenancePlanId('');
                    //     setUpdateMaintenancePlanStatusLoading(false)
                    // }, 3000);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                }, (err) => {
                    setUpdateMaintenancePlanStatusLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }))
    }

    return (
        <>
            < div className="row d-flex justify-content-center align-items-center" >
                <div className="col mx-3 align-items-center">

                    <div className="row mx-0">
                        <div className='col-12 d-flex'>
                            <div onClick={() => backToPrevious()} className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w500 cursor-pointer rounded-1 mb-1 d-flex align-items-center'>
                                <i class="bi bi-arrow-left-short pe-2"></i>
                                <span>{"Back"}</span>
                            </div>
                        </div>
                    </div>


                    <div className="row mx-0">
                        <div className="col-12 px-2">
                            <div>
                                <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0 d-flex  align-items-center justify-content-center">
                                        <span className="fs-3 font-w700 text-center text-black">
                                            {'Maintenance Tasks'}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0 d-flex align-items-center justify-content-center">
                                        <span className="fs-5 font-w600 text-center">
                                            {'The maintenance tasks are intended to help you extend the life and safety of the inventory items in your home'}
                                        </span>
                                    </div>
                                </div>


                                <div className='row mx-0'>
                                    <div className='col-12 px-0'>

                                        <div className='row mx-0'>
                                            <div className='col-12 px-0 d-flex border-bottom overflow-auto'>

                                                <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(4)}
                                                >
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-6 rounded-top text-white '
                                                        style={{
                                                            background: maintenanceTabsToggle === 4 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                            width: '120px'
                                                        }}
                                                    >
                                                        <span>{`All`}</span>
                                                    </div>
                                                    <div
                                                        className={`d-flex justify-content-center align-items-center p-2 fs-4 w-100 ${maintenanceTabsToggle === 4 ? "font-w700 text-black" : "font-w600"}`}
                                                        style={{
                                                            background: maintenanceTabsToggle === 4 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                    >
                                                        {/* <span>{maintenanceObj?.total_count}</span> */}
                                                        <span>{allHomeMaintenancePlanCount}</span>
                                                    </div>

                                                </div>

                                                <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(1)}
                                                >
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-6 rounded-top text-white'
                                                        style={{
                                                            background: maintenanceTabsToggle === 1 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                            width: '120px'
                                                        }}
                                                    >
                                                        <span>{`In 30 Days`}</span>
                                                    </div>
                                                    <div
                                                        className={`d-flex justify-content-center align-items-center p-2 fs-4 w-100 ${maintenanceTabsToggle === 1 ? "font-w700 text-black" : "font-w600"}`}
                                                        style={{
                                                            background: maintenanceTabsToggle === 1 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                    >
                                                        <div>
                                                            {/* <span>{maintenanceObj?.home_maintenance_plan_in_30_days_count}</span> */}
                                                            <span>{secondCount}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(2)}
                                                >
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-6 rounded-top text-white'
                                                        style={{
                                                            background: maintenanceTabsToggle === 2 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                            width: '120px'
                                                        }}
                                                    >
                                                        <span>{`In 60 Days`}</span>
                                                    </div>
                                                    <div
                                                        className={`d-flex justify-content-center align-items-center p-2 fs-4 w-100 ${maintenanceTabsToggle === 2 ? "font-w700 text-black" : "font-w600"}`}
                                                        style={{
                                                            background: maintenanceTabsToggle === 2 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                    >
                                                        <div>
                                                            {/* <span>{maintenanceObj?.home_maintenance_plan_in_60_days_count}</span> */}
                                                            <span>{thirdCount}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(3)}
                                                >
                                                    <div
                                                        className='d-flex justify-content-center align-items-center p-2 fs-6 rounded-top text-white'
                                                        style={{
                                                            background: maintenanceTabsToggle === 3 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                            width: '120px'
                                                        }}
                                                    >
                                                        <span>{`In 90 Days`}</span>
                                                    </div>
                                                    <div
                                                        className={`d-flex justify-content-center align-items-center p-2 fs-4 w-100 ${maintenanceTabsToggle === 3 ? "font-w700 text-black" : "font-w600"}`}
                                                        style={{
                                                            background: maintenanceTabsToggle === 3 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                    >
                                                        <div>
                                                            {/* <span>{maintenanceObj?.home_maintenance_plan_in_90_days_count}</span> */}
                                                            <span>{fourthCount}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div
                                            className="row  px-2 "
                                            style={{
                                                backgroundColor: "rgba(251, 252, 255, 1)",
                                            }}
                                        >

                                            <div
                                                className="row mx-0 my-2 align-items-center "
                                                style={{ minHeight: "40px" }}
                                            >
                                                <div className="col-12">
                                                    <div className="row">
                                                        <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                                                            <span className="fs-5 p-2 d-flex align-items-center">
                                                                <LuArrowUpDown
                                                                    className="pointer"
                                                                    style={{ marginRight: "4px", color: "black" }}
                                                                    onClick={handleOpenFiltreBox}
                                                                />
                                                                <span
                                                                    className="fs-6  pointer"
                                                                    style={{ position: "relative" }}
                                                                    onClick={handleOpenFiltreBox}>
                                                                    {filtreValue == 1 && "Date: Newest first"}
                                                                    {filtreValue == 2 && "Date: Oldest first"}

                                                                    &nbsp;
                                                                    {filtreBox ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                                    <span
                                                                        className={`${filtreBox ? "" : "d-none"} p-3`}
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "26px",
                                                                            width: "170px",
                                                                            zIndex: 1,
                                                                            border: "1px solid lightgray",
                                                                            background: "white",
                                                                            right: "0",
                                                                            boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                                        }}>
                                                                        <div className="row">
                                                                            <div
                                                                                className={`${filtreValue == 1 ? "dt" : ""
                                                                                    } d-flex justify-content-start m-1 pointer `}
                                                                                onClick={() => {
                                                                                    handleSetFiltreValue(1);
                                                                                }}>
                                                                                <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                                    {filtreValue == 1 && <i className="bi bi-check-lg"></i>}
                                                                                </div>
                                                                                Date: Newest first
                                                                            </div>
                                                                            <div
                                                                                className={`${filtreValue == 2 ? "dt" : ""
                                                                                    } d-flex justify-content-start m-1 pointer`}
                                                                                onClick={() => {
                                                                                    handleSetFiltreValue(2);
                                                                                }}>
                                                                                <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                                    {filtreValue == 2 && <i className="bi bi-check-lg"></i>}
                                                                                </div>
                                                                                Date: Oldest first
                                                                            </div>

                                                                        </div>
                                                                    </span>
                                                                </span>
                                                            </span>

                                                            <span
                                                                className="fs-6 p-2 d-flex align-items-center"
                                                                style={{
                                                                    border: "1px solid lightgray",
                                                                    borderRadius: "6px",
                                                                }}>
                                                                <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                                                <input
                                                                    placeholder="Search"
                                                                    style={{ border: "0px", width: "100%" }}
                                                                    onChange={handleSearch}
                                                                    value={searchValue}
                                                                />
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className='row mx-0 mb-3'>
                                            <div className='col-12 px-0'>
                                                {maintenancePlansArr.length > 0 ?
                                                    <>
                                                        {maintenancePlansArr?.map((item, ind) => {
                                                            return (
                                                                <>
                                                                    <div
                                                                        key={ind}
                                                                        className="row mx-0 "
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                        }}
                                                                        style={{ cursor: 'default' }}
                                                                    >
                                                                        <div
                                                                            className="col-12 px-3 border-top"
                                                                            style={{
                                                                                background: 'rgb(199 212 234 / 30%)',
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="d-flex align-items-center justify-content-between w-100 py-3 font-w600  text-black text-hovered"
                                                                            // onClick={() => {
                                                                            //     if (item?.home_area_product_id_ids === isExpandedForProduct) {
                                                                            //         setIsExpandedForProduct('')
                                                                            //     } else {
                                                                            //         setIsExpandedForProduct(item?.home_area_product_id_ids)
                                                                            //     }
                                                                            // }}
                                                                            >
                                                                                <div className="me-4 d-flex">
                                                                                    <div className='me-3 position-relative'>
                                                                                        <div className='position-absolute'
                                                                                            style={{
                                                                                                top: '-15px',
                                                                                                right: '-5px',
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                item?.condition_chr === "Good" ?
                                                                                                    <IoCheckmarkCircleOutline
                                                                                                        style={{ height: '18px', width: '18px', color: 'rgba(45, 204, 99, 1)' }}
                                                                                                        className='bg-white rounded-circle shadow'
                                                                                                    /> :
                                                                                                    item?.condition_chr === "Ok" ?
                                                                                                        <TiSpanner
                                                                                                            style={{ height: '18px', width: '18px', color: 'rgba(255, 154, 32, 1)', border: '1px solid rgba(255, 154, 32, 1)' }}
                                                                                                            className='bg-white rounded-circle shadow'
                                                                                                        /> :
                                                                                                        item?.condition_chr === "Poor" ?
                                                                                                            <MdOutlineCancel
                                                                                                                style={{ height: '18px', width: '18px', color: 'rgba(240, 72, 72, 1)' }}
                                                                                                                className='bg-white rounded-circle shadow'
                                                                                                            /> : ''
                                                                                            }
                                                                                        </div>
                                                                                        <span
                                                                                            className=" p-2 rounded bg-white shadow-lg text-black"
                                                                                        >
                                                                                            <i
                                                                                                class="bi bi-cloud-hail-fill"
                                                                                                style={{ height: '20px', width: '20px' }}
                                                                                            ></i>
                                                                                        </span>
                                                                                    </div>

                                                                                    <span>{`${item?.product_name_chr}`}</span>
                                                                                </div>

                                                                                <div
                                                                                    className="text-black fs-4 d-flex align-items-center justify-content-center cursor-pointer"
                                                                                >
                                                                                    <span>
                                                                                        <span>
                                                                                            <span>
                                                                                                <i class="bi bi-chevron-right ms-2  px-1"></i>
                                                                                            </span>
                                                                                        </span>
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <div className="row mb-2 bg-white rounded-2 shadow-sm">
                                                                                <div className="col-12 p-1">

                                                                                    <div
                                                                                        className={`bg-white mb-1  rounded `}
                                                                                        style={{ margin: '0' }}
                                                                                    >
                                                                                        <div
                                                                                            className="row mx-1  py-2 px-3 d-flex align-items-center"
                                                                                        >
                                                                                            <div
                                                                                                className="row mx-0  cursor-pointer"
                                                                                                onClick={() => {
                                                                                                    if (item?.maintenance_plan_id_ids === isExpandedForMaintenancePlan) {
                                                                                                        setIsExpandedForMaintenancePlan('')
                                                                                                    } else {
                                                                                                        setIsExpandedForMaintenancePlan(item.maintenance_plan_id_ids)
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                <div className="col-4 pe-2 font-w500">
                                                                                                    <span>{`Maintenance`}</span>
                                                                                                </div>
                                                                                                <div className="col-8 d-flex align-items-center justify-content-between">
                                                                                                    <span className={`${item?.instruction_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.instruction_chr ? `${item?.instruction_chr}` : 'NA'}`}</span>

                                                                                                    <span>
                                                                                                        {item?.maintenance_plan_id_ids === isExpandedForMaintenancePlan ?
                                                                                                            <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i> :
                                                                                                            <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i>
                                                                                                        }
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>

                                                                                            {item?.maintenance_plan_id_ids === isExpandedForMaintenancePlan &&
                                                                                                <>
                                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                            <span>{`When`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8">
                                                                                                            <span className={`${item?.period_name_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.period_name_chr ? `In ${item?.period_name_chr}` : 'NA'}`}</span>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                            <span>{`Frequency`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8">
                                                                                                            <span className={`${item?.frequency_int && 'text-black'} font-w600 p-1 px-2`}>{`${item?.frequency_int ? `${item?.frequency_int} times in a ${item?.period_name_chr}` : 'NA'}`}</span>
                                                                                                        </div>
                                                                                                    </div>


                                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                            <span>{`Link`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8">
                                                                                                            {item?.purchase_link ?
                                                                                                                <a
                                                                                                                    className="text-hovered text-gray-800"
                                                                                                                    href={`${item?.purchase_link}`}
                                                                                                                    target="_blank"
                                                                                                                    rel="noreferrer"
                                                                                                                >
                                                                                                                    <span className={`font-w600 p-1 px-2`}>{`Purchase link`} <i className="bi bi-chevron-right me-2"></i> </span>
                                                                                                                </a> :
                                                                                                                <span className={`font-w600 p-1 px-2`}>{`NA`} </span>
                                                                                                            }
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                                        <div className="col-12">
                                                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                                                <div className="mx-2"></div>
                                                                                                                <div className="mx-2 d-flex align-items-center fs-4">

                                                                                                                    <div className="me-2">
                                                                                                                        <div className="tooltipCustom">
                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                                                            <span
                                                                                                                                className="cursor-pointer overlay-action-btn px-2 py-1 rounded-2 text-gray-800 text-hovered"
                                                                                                                                onClick={() => {
                                                                                                                                    updateMaitenancePlanFn(item);
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                <i className="bi bi-pencil"></i>
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    </div>

                                                                                                                    <div className="me-2">
                                                                                                                        <div className="tooltipCustom">
                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete"}</span>
                                                                                                                            <span
                                                                                                                                className="cursor-pointer overlay-action-btn px-2 py-1 rounded-2 text-gray-800 text-hovered"
                                                                                                                                onClick={() => {
                                                                                                                                    handleOpenMaintenancePlanModal(2);
                                                                                                                                    setMaintenancePlanId(item?.maintenance_plan_id_ids);
                                                                                                                                    setInstruction(item?.instruction_chr);
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                <i className="bi bi-trash"></i>
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>

                                                                                                        </div>
                                                                                                    </div>



                                                                                                </>
                                                                                            }

                                                                                        </div>
                                                                                    </div>



                                                                                    {item?.image_url && false &&
                                                                                        <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                            <div className="col-12">
                                                                                                <img
                                                                                                    src={item?.image_url}
                                                                                                    alt="Attachment"
                                                                                                    className="rounded-2 shadow-lg cursor-pointer"
                                                                                                    onClick={(e) => {
                                                                                                        handleOpenDoc(); setImageAttachURL(item?.image_url);
                                                                                                    }}
                                                                                                    style={{
                                                                                                        height: '60px',
                                                                                                        width: '60px',
                                                                                                        border: '1px solid orange'
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </div>

                                                                            <div
                                                                                className="row  px-0"
                                                                            // onClick={() => handleCheckboxChange(element)}
                                                                            >
                                                                                <div
                                                                                    className={`row pb-2`}
                                                                                >
                                                                                    <div className={`col-12 d-flex fs-6 font-w600 `}>
                                                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                                                            <div
                                                                                                className="me-4 d-flex align-items-center"
                                                                                                style={{
                                                                                                    pointerEvents: updateMaintenancePlanStatusLoading ? 'none' : 'auto',
                                                                                                    opacity: updateMaintenancePlanStatusLoading ? '0.5' : '1'
                                                                                                }}
                                                                                            >
                                                                                                <span
                                                                                                    className="me-2"
                                                                                                >
                                                                                                    {updateMaintenancePlanStatusLoading && (item?.maintenance_plan_id_ids === maintenancePlanId) ?
                                                                                                        <Spinner animation="border" size="sm" /> :
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            checked={item?.is_completed_ysn}
                                                                                                            className="form-check-input"
                                                                                                            id="customCheckBox4"
                                                                                                            onChange={(e) => {
                                                                                                                updateMaintenancePlanStatusFn(item);
                                                                                                                setMaintenancePlanId(item?.maintenance_plan_id_ids)
                                                                                                            }}
                                                                                                            onClick={() => { updateMaintenancePlanStatusFn(item); setMaintenancePlanId(item?.maintenance_plan_id_ids) }}
                                                                                                        />
                                                                                                    }
                                                                                                </span>
                                                                                                <span
                                                                                                    className="pt-1 cursor-pointer text-hovered"
                                                                                                    onClick={() => {
                                                                                                        updateMaintenancePlanStatusFn(item);
                                                                                                        setMaintenancePlanId(item?.maintenance_plan_id_ids)
                                                                                                    }}
                                                                                                >
                                                                                                    {`Task Completed`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </> :
                                                    <>
                                                        <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                                            <div className="mb-2">
                                                                <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                            </div>
                                                            <span>
                                                                {`No items found`}
                                                            </span>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {/* Modal for previewing the attached image preview */}
            <>
                <Modal show={openDoc} onHide={handleCloseDoc} centered style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={imageAttachURL} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>

                    <>
                        <img src={imageAttachURL} alt='Error Loading' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>


            {/* <!-- Modal For the Maintenance plans operations --> */}
            <>
                <Modal
                    className="fade"
                    show={maintenanceModalTrigger}
                    centered
                // onHide={handleClose} 
                >
                    <Modal.Body>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>
                                <div className='mx-0 row text-black mb-3'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                                        <span
                                            onClick={() => handleCloseMaintenancePlanModal()}
                                            className='cursor-pointer text-hovered'
                                        >
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {toggleForMaintenancePlan === 1 ? `Edit maintenance plan` :
                                                toggleForMaintenancePlan === 2 ? `Delete maintenance plan` : ''
                                            }
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                                        <span>
                                            {(toggleForMaintenancePlan === 1) && `Fill in a maintenance plan for the item`}
                                            {(toggleForMaintenancePlan === 2) && `Are you sure you want to delete the ${instruction ? `"${instruction}"` : ''} maintenace plan?`}
                                        </span>
                                    </div>
                                </div>

                                {(toggleForMaintenancePlan === 1) &&
                                    <div
                                        className="row mx-0 py-2 font-w700 d-flex align-items-center"
                                        style={{
                                            // background: 'rgb(199 212 234 / 30%)',
                                            // pointerEvents: 'none',
                                            // opacity: '0.5',
                                        }}
                                    >
                                        <div className="col-12 p-2">
                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <InputField
                                                        labelName={"Instruction"}
                                                        value={instruction}
                                                        onChange={(e) => { handleChangeInstruction(e) }}
                                                        onBlur={() => { handleBlurCheckInstrction() }}
                                                        errorOccured={isInstructionErr}
                                                        errorMeesage={"Please enter instructions"}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <div className="row mx-0">
                                                        <div className="col-2 px-0 d-flex  justify-content-center">
                                                            <span className="font-w600 text-black">{`Every`}</span>
                                                        </div>
                                                        <div className="col-3 px-2">

                                                            <SelectInputFrequency
                                                                labelName={"Times"}
                                                                onChange={(e) => handleChangeFreq(e)}
                                                                defaultValue={frequency}
                                                                options={frequencyArr}
                                                                errorOccured={isFrequencyErr}
                                                                errorMessage={"Please select frequency"}
                                                            />

                                                        </div>
                                                        <div className="col-7 px-0">
                                                            <SelectInputPeriod
                                                                labelName={"Period"}
                                                                onChange={(e) => handleChangePeriod(e)}
                                                                defaultValue={period}
                                                                options={periodListArr}
                                                                errorOccured={isPeriodErr}
                                                                errorMessage={"Please select period"}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <InputField
                                                        labelName={"Purchase link (optional)"}
                                                        value={purchaseLink}
                                                        onChange={(e) => { handleChangePurchaseLink(e) }}
                                                        onBlur={() => { }}
                                                        errorOccured={false}
                                                        errorMeesage={"Please enter purchase link"}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <PrimaryButton
                                                        buttonName={"SUBMIT"}
                                                        onClick={() => { addUpdateMaintenancePlanFn() }}
                                                        isLoading={maintenancePlanLoading}
                                                        loadingMessage={"Loading..."}
                                                        style={{
                                                            width: '100%',
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {(toggleForMaintenancePlan === 2) &&
                                    <>
                                        <div className="row mx-0">
                                            <div className="col-sm-6 pe-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"NO, GO BACK"}
                                                    onClick={(e) => { handleCloseMaintenancePlanModal() }}
                                                    isLoading={false}
                                                    loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'rgba(251, 252, 255, 1)',
                                                        border: '1px solid rgba(199, 212, 234, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                        color: 'black'
                                                    }}
                                                />
                                            </div>

                                            <div className="col-sm-6 ps-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"YES, DELETE IT"}
                                                    onClick={(e) => { deletemaintenancePlanFn() }}
                                                    isLoading={maintenancePlanLoading}
                                                    loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                        border: '1px solid rgba(240, 72, 72, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </>


            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

        </>
    )
}

export default MaintenanceTasks;